import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { testId } from 'ui-components/services/testid-service';
import { MarkAsShippedContext } from '../../../context';

import style from './style.module.less';

const OrderNumber = ({ fulfillmentPlanId }) => {
  const {
    fulfillmentPlans: { [fulfillmentPlanId]: { orderNumber } = {} },
  } = useContext(MarkAsShippedContext);

  return (
    <div className={style['order-number-column']} {...testId('mark-as-shipped-order-number')}>
      {orderNumber || 'Na fam'}
    </div>
  );
};

OrderNumber.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default OrderNumber;
